import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Observable, from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { downloadFile } from 'src/app/utils/pdf-downloader';
import { urls } from 'src/app/utils/url-utils';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';
import { getBrokersList } from 'src/app/utils/utils.common';
declare var $;
@Component({
  selector: 'app-sweep-trips-modal',
  templateUrl: './sweep-trips-modal.component.html',
  styleUrls: ['./sweep-trips-modal.component.css']
})
export class SweepTripsModalComponent implements OnInit, OnDestroy {

  @Input() parsedTrips;
  @Output() onCloseModal = new EventEmitter<any>();
  selectedBroker = null;
  getListObserver: Observable<any>;
  unparsedData;
  selectedBrokerKey;
  // sendEmailAndDownloadModal = false;
  removedTripsList = { created: null };
  constructor(
    private assignTripService: AssigTripsService) {
  }

  ngOnInit() {
  }

  getBrokerName(name) {
    return getBrokersList[name];
  }

  onSelectBroker() {
    // this.selectedBroker = brokerType;
    this.selectedBroker = this.parsedTrips.find(broker => broker._id === this.selectedBrokerKey);
    console.log('selectedBroker = ', this.selectedBroker);
  }

  viewUnparsedTrips(rawId) {
    this.unparsedData = null;
    // this.store.dispatch(new ViewUnparsedTripsDetail({ rawId }));
  }

  sortMethod(a, b) {
    return new Date(a.value.created) < new Date(b.value.created) ? 1 : -1;
  }

  unParsedData() {
    let unparsedData = '';
    // tslint:disable-next-line: forin
    for (const data in this.unparsedData) {
      unparsedData = unparsedData + this.unparsedData[data] + ',';
    }
    return unparsedData;

  }

  generateFile(payload) {
    sweetAlert('Alert', 'Are you sure you want to delete this file?', 'warning', 'Yes', 'No')
      .then((result: any) => {
        if (result.value) {
          this.assignTripService
            .removeSweepTrips(payload)
            .pipe(takeUntil(componentDestroyed(this)))
            .subscribe(data => {
              if (data) {
                // sweetAlert('Success', 'File Sweeped Successfully', 'success', 'OK'
                this.parsedTrips.forEach((file) => {
                  if (file._id === this.selectedBroker._id){
                    const index = file.scraps.findIndex((file) => file._id === payload._id);
                    file.scraps.splice(index, 1);
                  }
                })
                this.removedTripsList = data.archive ? data.archive : null;
              }
            })
        }
      })
  }

  sendMail(tripList) {
    this.assignTripService
      .sendTripListEmail(tripList)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // sweetAlert('Success', 'Email Sent', 'success', 'OK');
        }
      }, err => {
        sweetAlert('Error', err, 'error', 'OK');
      });
  }
  download(tripList) {
    let url = urls.SERVER_URL;
    const fileExtention = 'xlsx';
    const fileName = tripList.name;
    url = url + 'excel/' + fileName;
    downloadFile(url, fileExtention, fileName);
    // sweetAlert('Success', 'File Downloaded', 'success', 'OK');
  }

  closeDetailModal() {
    this.onCloseModal.emit();
  }

  ngOnDestroy(): void {
  }

}
